import React from "react";
import { FieldLabel } from "./FieldLabel";

interface IWithLabelProps {
  children: React.ReactNode;
  label: string;
  labelId?: string;
  showLabel?: boolean;
}
export const WithLabel: React.FC<IWithLabelProps> = ({
  children,
  label,
  labelId,
  showLabel,
}) => {
  return showLabel ? (
    <FieldLabel label={label} labelId={labelId}>
      {children}
    </FieldLabel>
  ) : (
    <>{children}</>
  );
};
